import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Tab, Tabs } from '@mui/material'
import React, { useState } from 'react'
import { useFetchData } from '../../../../hooks/useFetchData/useFetchData';
import { useShowMessages } from '../../../../hooks/useMessages/useMessages';
import ClientsActualizations from '../systems/clientsActualizations';
import ClienteFinanceDetails from '../finance';
import Choice from '../../../shared/Choice';
import ClientDetails from './details';
import ClientRequestsDetails from '../requestsDetails';
import { useCryptoSessionStorage } from '../../../../hooks/useCryptoSessionStorage';
import { consts } from '../../../../config/config';
import dayjs from 'dayjs';

let url = process.env.REACT_APP_API+ "/client/";

const getTaxRegimeLabel = (value) => {
  const normalized = Number(value);

  if (value === null || value === undefined || Number.isNaN(normalized) || normalized === 0) {
    return 'Nenhum';
  }

  switch (normalized) {
    case 1:
      return 'MEI (Microempreendedor Individual)';
    case 2:
      return 'Simples Nacional';
    case 3:
      return 'Lucro Presumido';
    case 4:
      return 'Lucro Real';
    default:
      return 'Nenhum';
  }
};

const Client = (props) => {
  const { getData } = useCryptoSessionStorage();
  const user = getData("user") || {};
  const { editData, postData } = useFetchData()
  const { ShowMessage } = useShowMessages();
  const [page, setPage] = useState(0);

  const handleChange = (event, newValue) => {
    setPage(newValue);
  };

  const handlerChangeValues = (value) => {
    props.setValues((prevValues) => ({
      ...prevValues, 
      [value.target.name] : value.target.value,
    }));

  };

  const handleClose = () => {
    props.setOpen(false);

  }

  const handleClickSend = async () => {
    handleClose();
    // const res =  (!props.editing) ? await postData(url, props.values) : await editData(url, props.values);
    // if(res.success){
    //   ShowMessage('success', res.msg);
    //   props.handleChanged();
    //   handleClose();
    // }else{

    //   ShowMessage('error', res.msg);

    // }
  }

  const handleClickSendInfotechData = async () => {
  const body = {
    cpf_cnpj: props.values?.cpf_cnpj,
    bkp_user: props.values?.bkp_user || '',
    bkp_password: props.values?.bkp_password || '',
    certificate_password: props.values?.certificate_password || '',
    certificate_start: dayjs(props.values?.certificate_start).format('YYYY-MM-DD') || null,
    certificate_end: dayjs(props.values?.certificate_end).format('YYYY-MM-DD') || null,
    certifier: props.values?.certifier || '',
    bkp_responsibles: props.values?.bkp_responsibles || '',
    bkp_config_date:  dayjs(props.values?.bkp_config_date).format('YYYY-MM-DD HH:mm:ss') || null,
    bkp_technician: props.values?.bkp_technician || ''
  };

  const result = await editData(url + 'editTechInfo', body);
  if (result.success) {
    ShowMessage('success', result.msg);
    props.handleChanged?.(); // caso use um refresh

    props.setValues(prev => ({
      ...prev,
      ...body
    }));

    handleClose();
  } else {
    ShowMessage('error', result.msg);
    }
  
  };

  const handleChangeChecks = (value) => {
    props.setValues((prevValues) => ({
      ...prevValues, 
      [value.target.name] : (value.target.checked) ? 'Y' : 'N',
    }));
  }

  return (
    <div>  
      <Dialog open={props.open} >
        <DialogTitle >Cadastro de Cliente</DialogTitle>
        <DialogContent sx={{minHeight: '70vh', width: 600}}>
          <Tabs
            value={page}
            indicatorColor="primary"
            textColor="primary"
            onChange={handleChange}
            aria-label="Cadastro de Clientes"
            variant="fullWidth"
            sx={{mb: 1, fontSize: consts.FONT_SIZE}}
          >
            <Tab label="Dados"/>
            <Tab label="Sistemas" disabled={false} sx={{display: user?.administration_clients_systems === 'Y' ? 'block' : 'none'}}/>
            <Tab label="Financeiro" disabled={false} sx={{display: user?.administration_clients_finance === 'Y' ? 'block' : 'none'}}/>
            <Tab label="Atendimentos" disabled={false} sx={{display: user?.administration_clients_requests === 'Y' ? 'block' : 'none'}}/>
          </Tabs>
          <Choice.When  condition={page === 0} >
            <ClientDetails values={props.values} taxRegimeLabel={getTaxRegimeLabel(props.values?.tax_regime)} />            
          </Choice.When> 
          <Choice.When condition={page === 1} >
            <ClientsActualizations client={props.values} setValues={props.setValues} canEditTech={user?.edit_client_tech_info === 'Y'} />
          </Choice.When>
          <Choice.When condition={page === 2}>
            <ClienteFinanceDetails client={props.values?.id_gerente}/>
          </Choice.When> 
          <Choice.When condition={page === 3}>
            <ClientRequestsDetails client={props.values?.id}/>
          </Choice.When> 
        </DialogContent>
        <DialogActions sx={{ paddingRight: 4 }}>
          {page === 1 && user.edit_client_tech_info === 'Y' && (
        <Button onClick={() => handleClickSendInfotechData()} variant="outlined" size="small" color="success">Salvar</Button>
      )}
      <Button onClick={handleClose} variant="outlined" color="error" size="small">Fechar</Button>
      </DialogActions>
      </Dialog>
    </div>
  )
}

export default Client;
